import React from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { useModal } from '../Contex.js';
import { UPDATE_MOBILE } from '../graphql/Mutation/Signin.js';
import { useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { GET_ROLE_USER } from '../graphql/Query/Signin.js';
import { IoClose } from 'react-icons/io5';

const MobileUpdate = () => {
    const { modalOpen, setModalOpen } = useModal();
    const [updateMobile] = useMutation(UPDATE_MOBILE);
    const { data: getUser } = useQuery(GET_ROLE_USER);
    // console.log('✌️getUser --->', getUser);
    const id = localStorage.getItem('id');
    // console.log('✌️id --->', id);
    const formik = useFormik({
        initialValues: { phoneNumber: '' },
        validationSchema: Yup.object({
            phoneNumber: Yup.string()
                .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
                .required('Phone number is required'),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                const { data } = await updateMobile({
                    variables: {
                        mobileNumberUpdateUserId: getUser?.me?.id || id,
                        mobile: values?.phoneNumber,
                    },
                });

                if (data?.mobileNumberUpdateUser) {
                    setModalOpen(false)
                    toast.success('Mobile Number Added successfully!');
                    resetForm();
                }
            } catch (error) {
                toast.error(error.message);
            }
        },
    });

    const handleModalClose = () => {
        setModalOpen(false)
        formik.resetForm();
    };

    return (
        <div>
            {modalOpen && (
                <Dialog
                    open={modalOpen}
                    onClose={handleModalClose}
                    className="fixed inset-0 z-50 bg-black bg-opacity-65 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
                >
                    {/* <Dialog.Panel className="relative w-full max-h-screen overflow-y-auto transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl"> */}
                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                <DialogPanel className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                        <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">

                                            <div className="flex items-start justify-between">
                                                <DialogTitle className="text-lg font-bold text-gray-900">Mobile Number Verification</DialogTitle>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        onClick={() => { handleModalClose() }}
                                                        className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                                    >
                                                        <span className="absolute -inset-0.5" />
                                                        <span className="sr-only">Close panel</span>
                                                        <IoClose aria-hidden="true" className="size-6" />
                                                    </button>
                                                </div>
                                            </div>



                                            <form onSubmit={formik.handleSubmit}>
                                                <div className="mb-4 mt-10">
                                                    <label
                                                        htmlFor="phoneNumber"
                                                        className="block mb-2 font-medium text-gray-700"
                                                    >
                                                        Mobile No.
                                                    </label>
                                                    <p className='text-sm'>Enter your mobile number to continue.</p>
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-slate-50 text-gray-500 sm:text-sm">
                                                            +91
                                                        </span>
                                                        <input
                                                            id="phoneNumber"
                                                            name="phoneNumber"
                                                            type="text"
                                                            placeholder="Enter Mobile Number"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.phoneNumber}
                                                            className="flex-1 block w-full px-3 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                        />
                                                    </div>
                                                    {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                                                        <div className="text-red-600 text-sm mt-1">
                                                            {formik.errors.phoneNumber}
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <button
                                                    type="submit"
                                                    disabled={formik.isSubmitting}
                                                    className="w-full rounded-md bg-slate-900 px-3 py-2.5 text-sm font-semibold text-white hover:bg-slate-900 sm:mt-1"
                                                >
                                                    Submit
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="sticky text-sm bottom-0 bg-slate-100 px-4 py-3 sm:px-6 rounded-b-lg">
                                        <p>Your current mobile number is +91 {getUser?.me?.mobile}. If there’s an error, please update it before continuing.</p>
                                    </div>
                                </DialogPanel>
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
};

export default MobileUpdate;
